module.exports = __webpack_public_path__ + "static/media/5.717c8c8c.jpg";